import CallApi from '../../apiClient'
import { routes } from './routes'

export const userDataList = async (params) => {
  return CallApi({ ...routes.users, params })
}

export const usersDataCount = async (params) => {
  return CallApi({ ...routes.users_count, params })
}

export const listRoles = async (params) => {
  return CallApi({ ...routes.list_roles, params })
}

export const updateUser = async (guid, data) => {
  const params = {
    ...routes.update_user
  }
  params.url = params.url.replace(':guid', guid)

  return CallApi(params, data)
}

export const deleteUser = async (guid) => {
  return CallApi(
    {
      ...routes.delete_user,
      url: routes.delete_user.url.replace(':guid', guid)
    }
  )
}
